export default __webpack_public_path__ + "static/media/zoom.b1f01ff2.png";